import React from "react";
import { SvgIcon } from "./SvgIcons";

function FormError({ message }) {
	return (
		<div>
			<span className="form-error">
				<SvgIcon name="warning" /> {message}
			</span>
		</div>
	);
}

export default FormError;
